import React from 'react';
import LandingLayout from './components/LandingLayout';
import HeroSection from './components/HeroSection';
import SocialProofBar from './components/SocialProofBar';
import NewspaperShowcase from './components/NewspaperShowcase';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturesGrid from './components/FeaturesGrid';
import PrivacySection from './components/PrivacySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function LandingPage() {
  return (
    <LandingLayout>
      <HeroSection />
      <SocialProofBar />
      <NewspaperShowcase />
      <HowItWorksSection />
      <FeaturesGrid />
      <PrivacySection />
      <TestimonialsSection />
      <CTASection />
    </LandingLayout>
  );
}
